import { Grid, Stack, Typography } from "@mui/material";
import TanitaMC780BIAInfoCard from "../components/tanita/mc780/TanitaMC780BIAInfoCard";
import TanitaMC780BasicHealthTableCard from "../components/tanita/mc780/TanitaMC780BasicHealthTableCard";
import TanitaMC780BodyType from "../components/tanita/mc780/TanitaMC780BodyType";
import TanitaMC780FatRadarCard from "../components/tanita/mc780/TanitaMC780FatRadarCard";
import TanitaMC780LegMuscleCard from "../components/tanita/mc780/TanitaMC780LegMuscleCard";
import TanitaMC780MetabolismCard from "../components/tanita/mc780/TanitaMC780MetabolismCard";
import TanitaMC780MuscleBalanceCard from "../components/tanita/mc780/TanitaMC780MuscleBalanceCard";
import TanitaMC780MuscleRadarCard from "../components/tanita/mc780/TanitaMC780MuscleRadarCard";
export default function TanitaMC780Report({ healthData }) {
  return (
    <Stack direction="column" gap={4}>
      <Stack>
        <Typography variant="h5">詳細測量結果 (MC-780)</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaMC780BasicHealthTableCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaMC780BodyType data={healthData} />
          </Grid>
        </Grid>
      </Stack>

      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TanitaMC780MetabolismCard data={healthData} />
          </Grid>
        </Grid>
      </Stack>

      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaMC780MuscleRadarCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaMC780FatRadarCard data={healthData} />
          </Grid>
        </Grid>
      </Stack>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} lg={3}>
            <TanitaMC780MuscleBalanceCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <TanitaMC780LegMuscleCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <TanitaMC780BIAInfoCard data={healthData} />
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
}
